// extracted by mini-css-extract-plugin
export var sliderRange = "_mh-2";
export var sliderRoot = "_mh-0";
export var sliderThumb = "_mh-3";
export var sliderTrack = "_mh-1";